import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const translationsApi: any = createApi({
  reducerPath: "translationsApi",
  baseQuery: fetchBaseQuery({
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    translations: builder.query({
      query: (arg: string) => {
        return {
          url: arg,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useTranslationsQuery } = translationsApi;
